import React from 'react';
import PageTemplate from 'components/common/PageTemplate';
import ItemSelectContainer from 'containers/items/ItemSelectContainer';
import MenuTreeContainer from 'containers/items/MenuTreeContainer';

import { Helmet, HelmetProvider } from "react-helmet-async";
import { useParams } from 'react-router-dom';
import AdblockModal from 'components/adsense/AdblockModal/AdblockModal';

import { useSelector } from 'react-redux';

const ItemSelectPage = () => {
  const {id} = useParams();

  const itemName = useSelector(state => {
    const currSelWeapon = state.items?.toJS?.().currSelWeapon;
    return currSelWeapon?.currItem?.ITEM_NM;
  });

  return (
    <PageTemplate>
      <AdblockModal/>
      <HelmetProvider>
        <Helmet>
          <title>
            {itemName
              ? `이터널시티 ${itemName} 상세정보 | 이터인포`
              : '이터널시티 아이템 상세정보 | 이터인포'}
          </title>
          <meta name="description" content="착용부위별 등급별 이터널시티 무기 방어구 악세서리 아이템정보. 불법무기 CL 아이템 목록조회" />
        </Helmet>
      </HelmetProvider>

      <MenuTreeContainer/>
      <ItemSelectContainer id={id} key={id}/>
    </PageTemplate>
  );
};

export default ItemSelectPage;